'use client';

import React from 'react';
import Link from 'next/link';
import Footer from '@/components/footer';
import Navigation from '@/components/navigation';
import Contact from '@/components/contact';

export default function TermsPage(): React.ReactElement {
  return (
    <>
      <Navigation solid />
      <div className="container mx-auto px-4 py-8 min-h-screen mt-24">
        <div className="max-w-3xl mx-auto">
          <div className="relative mb-8">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white mb-4">
              Terms of Service
            </h1>
            <div className="h-1 w-16 bg-amber-500"></div>
          </div>
          <div className="prose prose-invert max-w-none">
            <div className="space-y-8">
              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                  Overview
                </h2>
                <p className="text-base sm:text-lg text-white/80">
                  These Terms of Service ("Terms") govern your use of this website
                  (the "Site"). By accessing or using the Site, you agree to be
                  bound by these Terms. If you do not agree, please do not use
                  the Site.
                </p>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                  Use of Content
                </h2>
                <ul className="list-disc ml-4 sm:ml-6 space-y-2 text-base sm:text-lg text-white/80">
                  <li>All content on this Site is for informational and personal use only.</li>
                  <li>You may not copy, reproduce, distribute, or create derivative works from any content without express written permission.</li>
                  <li>Unauthorized use of content may violate copyright, trademark, and other laws.</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                  User Conduct
                </h2>
                <ul className="list-disc ml-4 sm:ml-6 space-y-2 text-base sm:text-lg text-white/80">
                  <li>You agree not to use the Site for any unlawful purpose or in any way that could harm the Site or its users.</li>
                  <li>You may not attempt to gain unauthorized access to any part of the Site or its systems.</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                  Additional Terms
                </h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                      Links to Third-Party Sites
                    </h3>
                    <p className="text-base sm:text-lg text-white/80">
                      This Site may contain links to third-party websites. We are
                      not responsible for the content or privacy practices of
                      those sites.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                      Disclaimer
                    </h3>
                    <p className="text-base sm:text-lg text-white/80">
                      The Site is provided on an "as is" and "as available"
                      basis. We make no warranties, express or implied, regarding
                      the Site or its content.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                      Limitation of Liability
                    </h3>
                    <ul className="list-disc ml-4 sm:ml-6 space-y-2 text-base sm:text-lg text-white/80">
                      <li>We are not liable for any damages arising from your use of the Site.</li>
                      <li>Your sole remedy for dissatisfaction with the Site is to stop using it.</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 sm:p-8 hover:border-slate-700 transition-colors">
                <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-white mb-4">
                  Updates & Contact
                </h2>
                <div className="space-y-4">
                  <p className="text-base sm:text-lg text-white/80">
                    We may update these Terms from time to time. Changes will be
                    posted on this page with an updated effective date. Continued
                    use of the Site constitutes acceptance of the revised Terms.
                  </p>
                  <p className="text-base sm:text-lg text-white/80">
                    If you have any questions about these Terms, please use the
                    contact form on this website.
                  </p>
                  <p className="text-sm text-white/60 mt-4">
                    Effective date: April 17, 2025
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </>
  );
}
